export default __webpack_public_path__ + "assets/haze-night.7c71037c.svg";